const $body = $('body')
let canSubmit = 1
$body.on('submit', '#sign-up-for-news', function (e){
  e.preventDefault()

  const form = $(this)

  if(isValidForm(form) === 1 && canSubmit === 1) {

    canSubmit = 0

    let formData = form.serialize()

    $.ajax({
      type: 'POST',
      url: localize_script.admin_ajax,
      data: formData,
      success: function (results) {

        canSubmit = 1

        if (results.success === 1) {
          $('#sign-up-for-news .form-fields').hide()
          $('#sign-up-for-news .form-success').removeClass('d-none')
        }
      },
    })


  }


})

function isValidForm(form)
{
  let valid = 1

  form.find('.has-error').removeClass('has-error')

  form.find('.form-input.is-required').each(function (){
    if($(this).find('input').val().length <= 3) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  form.find('.form-email.is-required').each(function (){
    if(!validEmail($(this).find('input').val())) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  form.find('.form-checkbox.is-required').each(function (){
    if(!$(this).find('input').is(':checked')) {
      valid = 0
      $(this).addClass('has-error')
    }
  })

  return valid
}

// email validation
function validEmail (e) {
  let filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
  return String(e).search(filter) !== -1
}
